module.exports = __webpack_public_path__ + "static/rivella_waves_right-e946e9d21f4ec792996afcaaa54d599e.mp4";